const internetRegistrations = {
  title: "Internetanmeldungen zur Prüfung",
  entryHeaderLabel: "Internetanmeldung",
  entryHeaderDateTime: "{{date}} · {{time}}",
  newRegistration: "Neue Anmeldung",
  duplicateCandidate: "Mögliches Duplikat (bestehend)",
  duplicateCandidateGone: "Der verglichene Kundenakt ist nicht mehr vorhanden.",
  mergeUnavailable: "Ohne den verglichenen Kundenakt gibt es nichts zu fusionieren.",
  fields: {
    caseNumber: "EDV-#",
    birthday: "Geburtsdatum",
    insuranceNumber: "SV-Nummer",
    assignedCounselor: "Bearbeiter:in",
  },
  matching: {
    label: "Übereinstimmend:",
    lastName: "Nachname",
    firstName: "Vorname",
    birthday: "Geburtsdatum",
  },
  actions: {
    notADuplicate: "Kein Duplikat",
    merge: "Fusionieren",
  },
  empty: "Zurzeit gibt es keine Internetanmeldungen zu prüfen.",
  loading: "Internetanmeldungen werden geladen",
  loadFailed: "Die Internetanmeldungen konnten nicht geladen werden. Bitte laden Sie die Seite neu.",
  messages: {
    dismissed: "Die Anmeldung wurde als eigener Kundenakt behalten.",
  },
};

export default internetRegistrations;
